// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveModal-module__container--3Aqb8","title":"RemoveModal-module__title--2XjYM","text":"RemoveModal-module__text--26574","footer":"RemoveModal-module__footer--36t97"};